module.exports = __webpack_public_path__ + "img/drink-responsible.95bbd782.svg";